import { render, staticRenderFns } from "./QuestionDifficultyTrendMobile.vue?vue&type=template&id=0aa971a6&scoped=true"
import script from "./QuestionDifficultyTrendMobile.vue?vue&type=script&lang=js"
export * from "./QuestionDifficultyTrendMobile.vue?vue&type=script&lang=js"
import style0 from "./QuestionDifficultyTrendMobile.vue?vue&type=style&index=0&id=0aa971a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa971a6",
  null
  
)

export default component.exports